import React from 'react';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { NextSteps } from 'site-modules/write-review/components/next-steps/next-steps';

export function ThankYouPage({
  vehicle: {
    make: { name: makeName },
    model: { name: modelName },
    year,
  },
}) {
  return (
    <div className="thank-you-step text-gray-darker">
      <h1 className="heading-2 mb-0_5">Thank you for adding more details to your review</h1>
      <div className="mb-1_25">
        Your experience with the {year} {makeName} {modelName} is going to help other drivers figure out if this car is
        right for them!
      </div>
      <div>
        We review all submissions prior to publishing them, so it may take up to two business days for your review to
        appear.
      </div>
      <hr className="mt-1_5 mb-2" />
      <NextSteps hasHeading />
    </div>
  );
}

ThankYouPage.propTypes = {
  vehicle: VehicleEntities.MakeModelSubmodelYear.isRequired,
};
